import { deleteDeviceModal } from './deleteDeviceModalSlice';
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { fetchDeviceData } from '../../pages/deviceManagement/deviceSlice';
import useNotification from '../notification/useNotification';
import { isSuccessResponse } from '../../common/utils';
import { useSpinner } from '../ui/spinner/useSpinner';
import { IInitialSliceState } from '../../common/types/commonTypes';

interface IDeleteDeviceResponseState {
    deleteDeviceApi: IInitialSliceState
}

export const useDeleteDeviceModal = (deviceId?: string) => {
    const dispatch: any = useDispatch();
    const [showModel, setShowModel] = useState(false);
    const deleteDeviceResponse = useSelector((state: IDeleteDeviceResponseState) => state.deleteDeviceApi);
    useSpinner(deleteDeviceResponse.status);

    const handleClose = () => setShowModel(false);
    const handleShow = () => {
        setShowModel(true);
    };

    const { showSuccessNotification, showWarningNotification } = useNotification();
    
    const handleDeleteButtonClick = () => {
        dispatch(deleteDeviceModal(deviceId)).then((response)=>{
            if (isSuccessResponse(response.payload)) {
                dispatch(fetchDeviceData(''));
                showSuccessNotification(response.payload.message);
            }
            else {
              showWarningNotification(response.payload.response.data.message);
            }
        });;
        setShowModel(false);
    };

    return {
        handleDeleteButtonClick,
        showModel,
        handleShow,
        handleClose
    };
}